import request from '@/utils/request'


// 查询结算订单列表
export function listSettlementOrder(query) {
  return request({
    url: '/user/settlement-order/list',
    method: 'get',
    params: query
  })
}

// 查询结算订单分页
export function pageSettlementOrder(query) {
  return request({
    url: '/user/settlement-order/page',
    method: 'get',
    params: query
  })
}

// 查询结算订单详细
export function getSettlementOrder(data) {
  return request({
    url: '/user/settlement-order/detail',
    method: 'get',
    params: data
  })
}

// 新增结算订单
export function addSettlementOrder(data) {
  return request({
    url: '/user/settlement-order/add',
    method: 'post',
    data: data
  })
}

// 修改结算订单
export function updateSettlementOrder(data) {
  return request({
    url: '/user/settlement-order/edit',
    method: 'post',
    data: data
  })
}

// 删除结算订单
export function delSettlementOrder(data) {
  return request({
    url: '/user/settlement-order/delete',
    method: 'post',
    data: data
  })
}
